/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type CheckoutOrderingPaymentStepAddress_address$ref: FragmentReference;
declare export opaque type CheckoutOrderingPaymentStepAddress_address$fragmentType: CheckoutOrderingPaymentStepAddress_address$ref;
export type CheckoutOrderingPaymentStepAddress_address = {|
  +firstName: ?string,
  +lastName: ?string,
  +phone: ?string,
  +title: ?string,
  +city: ?string,
  +postalCode: ?string,
  +line2: ?string,
  +line1: ?string,
  +country: ?{|
    +alpha2: ?string,
    +name: ?string,
  |},
  +$refType: CheckoutOrderingPaymentStepAddress_address$ref,
|};
export type CheckoutOrderingPaymentStepAddress_address$data = CheckoutOrderingPaymentStepAddress_address;
export type CheckoutOrderingPaymentStepAddress_address$key = {
  +$data?: CheckoutOrderingPaymentStepAddress_address$data,
  +$fragmentRefs: CheckoutOrderingPaymentStepAddress_address$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "CheckoutOrderingPaymentStepAddress_address",
  "type": "Address",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "firstName",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "lastName",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "phone",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "title",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "city",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "postalCode",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "line2",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "line1",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "country",
      "storageKey": null,
      "args": null,
      "concreteType": "Country",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "alpha2",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "name",
          "args": null,
          "storageKey": null
        }
      ]
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '9761d2a1b69e55e7312b8b1e234a5c43';

module.exports = node;
